import clsx from 'clsx';
import { getDiscountNoticesForMonth } from '../../utils/_getCalendarDiscountNotices';
import {
  MONTH_NAMES,
  WEEKDAY_SHORT,
  generateMonthDays,
  filterAvailableDates,
} from '../../utils/calendarUtils';

const CalendarMonthSlide = ({
  year,
  month,
  items,
  allowedLengths,
  arrivalDate,
  discounts,
  onDateClick,
}) => {
  const freeDates = filterAvailableDates(items, allowedLengths);
  const monthDays = generateMonthDays(year, month);
  const freeDaysSet = new Set(freeDates.map((item) => item.d));
  const monthNotices = getDiscountNoticesForMonth(year, month, discounts);

  return (
    <div className='dates_swiper__slide'>
      <h2>
        {MONTH_NAMES[month - 1]} {year}
      </h2>
      <div className='dates_swiper__dates calendar-grid'>
        {WEEKDAY_SHORT.map((day) => (
          <span key={day} className='calendar-grid__weekday'>
            {day}
          </span>
        ))}
        {monthDays.map((day, idx) => {
          if (day === null) {
            return <span key={`empty-${idx}`} className='calendar-grid__day calendar-grid__day--empty' />;
          }

          const isFree = freeDaysSet.has(`${day}`);
          const dayData = freeDates.find((item) => item.d === `${day}`);

          return (
            <span
              key={`${year}-${month}-${day}-${idx}`}
              className={clsx(
                'calendar-grid__day',
                isFree && 'calendar-grid__day--free',
                dayData?.date === arrivalDate && 'calendar-grid__day--active'
              )}
              onClick={isFree ? () => onDateClick(dayData) : undefined}
            >
              {day}
            </span>
          );
        })}
      </div>
      {monthNotices.length > 0 && (
        <div className='dates_swiper__notices'>
          {monthNotices.map((notice) => (
            <p key={`${year}-${month}-${notice}`} className='dates_swiper__early-booking'>
              {notice}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarMonthSlide;
